import { bboxShape } from '@eventbrite/discover-utils';
import { gettext } from '@eventbrite/i18n';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import take from 'lodash/take';
import React from 'react';
import { useMount } from 'react-use';
import { CardBucket } from '../../../../../../components/CardBucket';
import { LIST_CARD_TEMPLATE } from '../../../../../../constants';
import { SEARCH_SECTION } from '../../../../../../constants/analytics';
import { FeatureFlags, ShareOptions } from '../../../../../../types/index';

interface EventSuggestionsProps {
    eventSuggestions: object[];
    shareOptions: ShareOptions;
    isAuthenticated?: boolean;
    allEventsUrl?: string;
    featureFlags: FeatureFlags;
    suggestionsLoading: boolean;
    searchEventSuggestionsAction: Function;
    hasEventResults: boolean;
    bbox: bboxShape;
    locale: string;
}

export const EventSuggestions = (props: EventSuggestionsProps) => {
    const {
        eventSuggestions,
        shareOptions,
        isAuthenticated,
        allEventsUrl,
        featureFlags,
        suggestionsLoading,
        searchEventSuggestionsAction,
        hasEventResults,
        bbox,
        locale,
    } = props;

    useMount(() => {
        if (!hasEventResults && !isEmpty(bbox)) {
            searchEventSuggestionsAction(true);
        } else if (isEmpty(eventSuggestions)) {
            searchEventSuggestionsAction();
        }
    });

    if (isEmpty(eventSuggestions) && !suggestionsLoading) {
        return null;
    }

    let content = map(eventSuggestions, (event = {}) => ({
        ...event,
        section: SEARCH_SECTION,
        excludeExtraContent: true,
        heapLocationString: 'Search - Empty State',
        event: { ...event },
    }));

    content = take(content, 5);

    return (
        <div className="pivot-section eds-l-pad-bot-4">
            <CardBucket
                locale={locale}
                isLoading={suggestionsLoading}
                content={content}
                template={LIST_CARD_TEMPLATE}
                shareOptions={shareOptions}
                section={SEARCH_SECTION}
                name={gettext('Popular events')}
                linkUrl={allEventsUrl}
                isAuthenticated={isAuthenticated}
                featureFlags={featureFlags}
                bucketKey="near_you"
            />
        </div>
    );
};
